import { ReactNode, MouseEvent } from 'react';
import { Button, Modal } from '@pairy/pds-react';

import { SetState } from '@/types/helper';

import * as Styled from './index.styles';

interface Props {
  isOpen: boolean;
  setIsOpen: SetState<boolean>;
  onClick: () => void;
  loading?: boolean;
  title?: string;
  content?: ReactNode;
  // 확인 버튼 문구 (기본 '삭제하기' — 환불 등 다른 파괴적 액션에도 재사용)
  confirmText?: string;
}

const DeleteConfirmModal = ({
  isOpen,
  setIsOpen,
  onClick,
  loading,
  content,
  title = '삭제 확인',
  confirmText = '삭제하기',
}: Props) => {
  const handleCancelButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsOpen(false);
  };

  const handleDeleteButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={setIsOpen}>
      <Modal.Content loading={loading} onClick={(e) => e.stopPropagation()}>
        <Modal.Header title={title} />
        <Modal.Body>
          <Styled.Wrapper>
            <div>{content}</div>
            <Styled.ButtonsWrapper>
              <Button
                variant="zinc_200"
                textVariant="lg-semibold"
                paddingY={16}
                paddingX={24}
                onClick={handleCancelButtonClick}
              >
                취소
              </Button>
              <Button
                variant="cerise_400_fill"
                textVariant="lg-semibold"
                paddingY={16}
                paddingX={24}
                onClick={handleDeleteButtonClick}
              >
                {confirmText}
              </Button>
            </Styled.ButtonsWrapper>
          </Styled.Wrapper>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};

export default DeleteConfirmModal;
